import React from "react";
import { NavLink } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import { useTranslation } from "react-i18next";
import "./TrainingStatusElement.css";

function TrainingStatusElement({ id, name, profile, trainings }) {
  const { t } = useTranslation();

  const trainingProgress = () => {
    let count = 0;
    for (const training of trainings) {
      if (training.status === "approved") {
        count++;
      }
    }

    if (trainings.length === 0) {
      return 0; // Avoid division by zero
    } else {
      return ((count / trainings.length) * 100).toFixed(2); // Calculate percentage
    }
  };

  const progressLabel = () => {
    let count = 0;
    for (const training of trainings) {
      if (training.status === "approved") {
        count++;
      }
    }

    if (trainings.length !== 0) {
      return `${count} / ${trainings.length}`;
    } else {
      return "";
    }
  };

  return (
    <Row className="training align-items-center">
      <Col lg={8} className="training-status-header">
        <NavLink className="nav-link" to={`/mytrainings/${id}`}>
          <h5>{name}</h5>
        </NavLink>
        <p>{profile}</p>
      </Col>
      <Col lg={4} className="training-content center">
        {trainings.length === 0 ? (
          <p>{t("Capacitaciones.Capacitacion.Estatus.SinEntrenamientos")}</p>
        ) : (
          <ProgressBar now={trainingProgress()} label={progressLabel()} />
        )}
      </Col>
    </Row>
  );
}

export default TrainingStatusElement;
